<template>
  <div class="page-head">
    <a-row  type="flex" justify="space-between" align="middle">
      <a-col>
        <a-breadcrumb class="bread-crumb">
          <a-breadcrumb-item v-for="(item, index) in breadList" :key="item.name">
            <!-- <router-link
              v-if="item.name != name && item.path"
              :to="{ path: item.path }"
            >{{ item.meta.title }}</router-link> -->
            <span>{{ item.meta.title || '设备管理平台'}}</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </a-col>
      <a-col v-if="showBack" @click="()=>{$router.go(-1)}" style="cursor: pointer;">
        <p style="margin-bottom: 10px;"><a-icon type="arrow-left" /> 返回</p>
      </a-col>
    </a-row>
    <!-- <h1 class="page-title">{{$route.meta.title}}</h1> -->
  </div>
</template>

<script>
export default {
  props: {
    showBack: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      name: '',
      breadList: []
    }
  },
  created () {
    this.getBreadcrumb()
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  methods: {
    getBreadcrumb () {
      this.breadList = [this.$route.matched[0]]
      this.name = this.$route.name
      this.$route.matched.forEach(item => {
        if (item.meta.bread) {
          this.breadList.push(item)
        }
      })
    }
  },
  computed: {},
  components: {}
}
</script>

<style scoped>
  .page-head{
    background: #fff;
    padding: 16px 32px 0;
    border-bottom: 1px solid #e8e8e8;
    width: 100%;
    position: absolute;
    z-index: 1;
  }
  .page-head .bread-crumb{
    margin-bottom: 10px;
  }
  .page-head .page-title{
    font-size: 20px;
    line-height: 28px;
    font-weight: 500;
    color: rgba(0,0,0,.85);
    margin-bottom: 10px;
  }
</style>
